import React, { useContext } from 'react';

import TextfieldUnit from '../../../../../../components/TextfieldUnit';

import ACTIONS from '../../../../../../../redux/action';
import prices from '../prices.json';
import { useSelector, useDispatch } from 'react-redux';
import classes from '../../PricingTab.module.scss';

import i18n from '../../../../../../../utils/i18n';

import { providerCompanyTypeList } from '../../../../../../data/providerText';
import InputContext from '../../../../../../../context/inputContext';

const AccountingPricing = () => {
	const isMobile = window.innerWidth < 480;
	const dispatch = useDispatch();
	const { isChanged, setIsChanged } = useContext(InputContext);
	const [accountingPrice, companyTypeFilter, priceCategory] = useSelector(
		(state) => [
			state.provider_acc_monthly_price,
			state.provider_business_filter,
			state.priceCategory,
		]
	);

	const handleChange = (event, storeObj) => {
		let value = event.target.value;
		dispatch(
			ACTIONS.addProviderInfo({
				id: `${event.target.id}price`,
				data: value,
				stateObject: storeObj,
			})
		);
		setIsChanged(true);
	};

	// const autoFill = (id, storeObj, price) => {
	// 	dispatch(
	// 		ACTIONS.addProviderInfo({
	// 			id: id,
	// 			data: price,
	// 			stateObject: storeObj,
	// 		})
	// 	);
	// };

	// const fillPrices = () => {
	// 	let category = priceCategory.category;
	// 	for (let item in companyTypeFilter) {
	// 		if (companyTypeFilter[item]) {
	// 			let id = `${[item]}price`;

	// 			autoFill(
	// 				id,
	// 				'provider_acc_monthly_price',
	// 				prices[category]['provider_acc_monthly_price'][id]
	// 			);
	// 		}
	// 	}
	// };

	return (
		<div
			style={{
				display: 'grid',
				gridTemplateColumns: isMobile ? 'repeat(1, 1fr)' : 'repeat(2, 1fr)',
				gap: '16px',
			}}>
			{providerCompanyTypeList().map((item) => {
				if (companyTypeFilter[item.id]) {
					return (
						<div className={classes.textfieldColumn} key={item.id}>
							<TextfieldUnit
								id={item.id}
								title={item.label}
								// placeholder=''
								isRequired={true}
								showAsterix={true}
								unit={`${i18n.t('general.currency')} / ${i18n.t(
									'general.month'
								)}`}
								value={accountingPrice[`${item.id}price`]}
								onChange={(event) =>
									handleChange(event, 'provider_acc_monthly_price')
								}
							/>
							{/* <div className={classes.baseFee}>
								{i18n.t('provider.pricingavgbasefeeindividual')}
							</div> */}
						</div>
					);
				}
			})}
		</div>
	);
};

export default AccountingPricing;
